export const FETCH_PARSEDTREES = 'FETCH_PARSEDTREES';
export const SET_PARSEDTREE = 'SET_PARSEDTREE';
export const GET_PARSEDTREE_INFO = 'GET_PARSEDTREE_INFO';
export const SET_PARSEDTREE_INFO = 'SET_PARSEDTREE_INFO';
export const ADD_PARSEDTREE = 'ADD_PARSEDTREE';
export const ADD_SUCCESS_PARSEDTREE = 'ADD_SUCCESS_PARSEDTREE';
export const FETCH_SEARCH_PARSEDTREE = 'FETCH_SEARCH_PARSEDTREE';
export const SET_SEARCH_PARSEDTREE = 'SET_SEARCH_PARSEDTREE';
export const FETCH_COUNTER_PARSEDTREE = 'FETCH_COUNTER_PARSEDTREE';
export const SET_COUNTER_PARSEDTREE = 'SET_COUNTER_PARSEDTREE';
export const UPDATE_PARSEDTREE = 'UPDATE_PARSEDTREE';
export const UPDATE_PARSEDTREE_ELEMENTS = 'UPDATE_PARSEDTREE_ELEMENTS';
export const SET_UPDATE_PARSEDTREE_ELEMENTS = 'SET_UPDATE_PARSEDTREE_ELEMENTS';
export const UPDATE_PARSEDTREE_FIELD = 'UPDATE_PARSEDTREE_FIELD';
export const SET_UPDATE_PARSEDTREE_FIELD = 'SET_UPDATE_PARSEDTREE_FIELD';
export const UPDATE_PARSEDTREE_FIELDTAGS = 'UPDATE_PARSEDTREE_FIELDTAGS';
export const SET_UPDATE_PARSEDTREE_FIELDTAGS = 'SET_UPDATE_PARSEDTREE_FIELDTAGS';
export const UPDATE_PARSEDTREE_FIELDSTAGS = 'UPDATE_PARSEDTREE_FIELDSTAGS';
export const SET_UPDATE_PARSEDTREE_FIELDSTAGS = 'SET_UPDATE_PARSEDTREE_FIELDSTAGS';
export const UPDATE_PARSEDTREE_TEMPLATEFIELDS = 'UPDATE_PARSEDTREE_TEMPLATEFIELDS';
export const SET_UPDATE_PARSEDTREE_TEMPLATEFIELDS = 'SET_UPDATE_PARSEDTREE_TEMPLATEFIELDS';
export const UPDATE_ARTBOARD_PREVIEW = 'UPDATE_ARTBOARD_PREVIEW';
export const EXPORT_ARTBOARD_MEDIA = 'EXPORT_ARTBOARD_MEDIA';

export const FETCH_PARSEDTREECHANGES = 'FETCH_PARSEDTREECHANGES';
export const SET_PARSEDTREECHANGES = 'SET_PARSEDTREECHANGES';
export const GET_PARSEDTREECHANGE = 'GET_PARSEDTREECHANGES';
export const RESTORE_PARSEDTREECHANGE = 'RESTORE_PARSEDTREECHANGE';

